import ImageOptimize from './ImageOptimize';

export default ImageOptimize;

export * from './interface';
